// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrganizationRecipientDTO
 */
export interface OrganizationRecipientDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationRecipientDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRecipientDTO
     */
    group: OrganizationRecipientDTOGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRecipientDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRecipientDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRecipientDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganizationRecipientDTOGroupEnum {
    DIRECT = 'DIRECT',
    INITIAL = 'INITIAL',
    ADMIN = 'ADMIN'
}



